import { render, staticRenderFns } from "./Bookcase.vue?vue&type=template&id=3a22ea99&scoped=true"
import script from "./Bookcase.vue?vue&type=script&lang=js"
export * from "./Bookcase.vue?vue&type=script&lang=js"
import style0 from "./Bookcase.vue?vue&type=style&index=0&id=3a22ea99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a22ea99",
  null
  
)

export default component.exports